import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ApplicationService {
  public readonly applicationVersion = document.head.querySelector<HTMLMetaElement>("[name='client-version']")?.content ?? '0';
}
